export default function () {
  if (document.getElementById('inbox-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "inbox-vue-app" */ '@organisms/inbox/main');
  }
}
